import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      id: 'ssl',
      icon: 'Shield',
      label: 'SSL Encrypted',
      description: '256-bit encryption'
    },
    {
      id: 'compliance',
      icon: 'CheckCircle',
      label: 'SOC 2 Compliant',
      description: 'Enterprise security'
    },
    {
      id: 'backup',
      icon: 'Database',
      label: 'Secure Backup',
      description: '99.9% uptime'
    }
  ];

  return (
    <div className="space-y-4">
      <div className="text-center">
        <h3 className="text-sm font-medium text-foreground mb-2">
          Enterprise-Grade Security
        </h3>
        <p className="text-xs text-muted-foreground">
          Your data is protected with industry-leading security measures
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {securityFeatures?.map((feature) => (
          <div
            key={feature?.id}
            className="flex flex-col items-center p-3 bg-muted/50 rounded-lg border border-border/50"
          >
            <div className="w-8 h-8 bg-success/10 rounded-full flex items-center justify-center mb-2">
              <Icon name={feature?.icon} size={16} className="text-success" />
            </div>
            <p className="text-xs font-medium text-foreground text-center mb-1">
              {feature?.label}
            </p>
            <p className="text-xs text-muted-foreground text-center">
              {feature?.description}
            </p>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-center gap-2 pt-2">
        <Icon name="Lock" size={14} className="text-muted-foreground" />
        <p className="text-xs text-muted-foreground">
          Protected by advanced threat detection
        </p>
      </div>
    </div>
  );
};

export default SecurityBadges;